module.exports = __webpack_public_path__ + "img/21.61d0a21f.png";